/* eslint-disable import/no-cycle */
import { put, takeEvery } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { hubAction } from "redux/slice/hub";
import {
  fetchHubContent,
  fetchWinWireMessages,
  addWinWireReaction,
  removeWinWireReaction,
  removeWinWireReply,
  addWinWireReply,
  editWinWireReply,
  fetchAllNotifications,
  removeHubNotifications,
  incrementHubNotification,
  muteNotification,
} from "apis/insights";

export function* getHubContent(action) {
  let errorMsg = "";
  try {
    const content = yield fetchHubContent(action.payload);

    if (content.data?.success) {
      yield put(hubAction.getHubContent(content.data.data));
    } else if (content.response?.status !== 403) {
      errorMsg = content.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
      yield put(hubAction.getHubContentFail());
    }
  }
}

export function* fetchNotifications(action) {
  let errorMsg = "";
  try {
    const content = yield fetchAllNotifications(action.payload);

    if (content.data?.success) {
      yield put(hubAction.setNotifications(content.data.notifications));
    } else if (content.response?.status !== 403) {
      errorMsg = content.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.fetchNotificationsFinished());
  }
}

export function* sendWinWireReply(action) {
  let errorMsg = "";
  try {
    const response = yield addWinWireReply(action.payload);

    if (!response.data?.success) {
      errorMsg = response.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.winWireFinished());
  }
}

export function* updateWinWireReply(action) {
  let errorMsg = "";
  try {
    const response = yield editWinWireReply(action.payload);

    if (!response.data?.success) {
      errorMsg = response.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.winWireFinished());
  }
}

export function* deleteWinWireReply(action) {
  let errorMsg = "";
  try {
    const response = yield removeWinWireReply(action.payload);

    if (!response.data?.success) {
      errorMsg = response.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.winWireFinished());
  }
}

export function* getWinWireMessages(action) {
  let errorMsg = "";
  try {
    const messages = yield fetchWinWireMessages(action.payload);

    if (messages.data?.success) {
      yield put(hubAction.getWinWireMessages({ winWireMessages: messages.data.data.winWire }));
    } else if (messages.response?.status !== 403) {
      errorMsg = messages.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
      yield put(hubAction.getWinWireMessagesFail());
    }
  }
}

export function* handleAddReaction(action) {
  let errorMsg = "";
  try {
    const response = yield addWinWireReaction(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.winWireFinished());
  }
}

export function* handleRemoveReaction(action) {
  let errorMsg = "";
  try {
    const response = yield removeWinWireReaction(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(hubAction.winWireFinished());
  }
}

export function* removeNotifications(action) {
  let errorMsg = "";
  try {
    const response = yield removeHubNotifications(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* incrementWinWireNotification() {
  let errorMsg = "";
  try {
    const { hash } = window.location;
    if (hash !== "#win-wire") {
      const response = yield incrementHubNotification({ notificationKey: "winWire" });
      if (!response.data?.success) {
        errorMsg = response?.data?.message || "Something went wrong";
      }
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* handleInsightMute(action) {
  let errorMsg = "";
  try {
    const response = yield muteNotification(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* watchHubAsync() {
  yield takeEvery(hubAction.getHubSaga, getHubContent);
  yield takeEvery(hubAction.sendWinWireReplySaga, sendWinWireReply);
  yield takeEvery(hubAction.updateWinWireReplySaga, updateWinWireReply);
  yield takeEvery(hubAction.deleteWinWireReplySaga, deleteWinWireReply);
  yield takeEvery(hubAction.fetchNotificationsSaga, fetchNotifications);
  yield takeEvery(hubAction.getWinWireMessagesSaga, getWinWireMessages);
  yield takeEvery(hubAction.addReaction, handleAddReaction);
  yield takeEvery(hubAction.removeReaction, handleRemoveReaction);
  yield takeEvery(hubAction.removeNotifications, removeNotifications);
  yield takeEvery(hubAction.addWinWireMessage, incrementWinWireNotification);
  yield takeEvery(hubAction.handleInsightMute, handleInsightMute);
}
